import { useMemo } from 'react';
import { useQueryParams } from '../useQueryParams';
import { useSession } from '../useSession';
import { convertSlugToConversationId } from 'src/utils';
import { DEFAULT_CHAT_ID, TEMPORARY_CONVERSATION_ID } from 'src/constants';
import { useComparingConversationsParams } from 'src/hooks';

// TODO(olha): divide into two separate hooks: useConversationsList, useCurrentConversation, useConversationActions
export const useConversationParams = (conversationId?: string | null) => {
  const { firstComparedConvId, secondComparedConvId, isCompareMode } =
    useComparingConversationsParams();

  const {
    searchParams: { conv, task },
  } = useQueryParams();

  const {
    appUser: { user_id },
    isOpenTier,
  } = useSession();

  const isTemporaryConversationId = useMemo(
    () => conv?.includes(TEMPORARY_CONVERSATION_ID),
    [conv],
  );
  const currentConversationId = useMemo(
    () =>
      isTemporaryConversationId && conv
        ? conv
        : // TODO(olha): DEFAULT_CHAT_ID is deprecated, should be removed
          convertSlugToConversationId(conv) || DEFAULT_CHAT_ID,
    [isTemporaryConversationId, conv],
  );

  const isLandingPage = useMemo(
    () =>
      currentConversationId === DEFAULT_CHAT_ID &&
      !firstComparedConvId &&
      !secondComparedConvId,
    [currentConversationId, firstComparedConvId, secondComparedConvId],
  );

  const shouldSkipForCompareMode = useMemo(
    () =>
      !firstComparedConvId ||
      !secondComparedConvId ||
      !user_id ||
      (firstComparedConvId !== conversationId &&
        secondComparedConvId !== conversationId),
    [firstComparedConvId, secondComparedConvId, user_id, conversationId],
  );

  const shouldSkipForDefaultMode = useMemo(
    () => isLandingPage || !user_id || (isOpenTier && !!task),
    [isLandingPage, isOpenTier, task, user_id],
  );

  const shouldSkipGetConversationById = useMemo(
    () => (isCompareMode ? shouldSkipForCompareMode : shouldSkipForDefaultMode),
    [isCompareMode, shouldSkipForCompareMode, shouldSkipForDefaultMode],
  );

  return useMemo(
    () => ({
      isLandingPage,
      currentConversationId,
      anchorTaskId: task,
      shouldSkipGetConversationById,
    }),
    [isLandingPage, currentConversationId, task, shouldSkipGetConversationById],
  );
};
